import styles from './Loader.module.scss';

const Loader = ({ size = 'medium', text = '' }) => {
    return (
        <div className={`${styles.loader} ${styles[size]}`}>
            <div className={styles.spinner}>
                <div className={styles.ring}></div>
                <div className={styles.ring}></div>
                <div className={styles.ring}></div>
            </div>
            {text && <p className={styles.text}>{text}</p>}
        </div>
    );
};

export default Loader;
